<template>
  <div>
    <v-layout row wrap>
      <v-flex xs11>
        <v-layout row wrap mr-4>
          <v-flex xs12 md4 pr-4>
            <v-text-field
              v-model="loan.LendingInstitutionName" 
              :rules="[rules.Lender]" 
              :label="`Lending Institution ${idx+1} Name:`"
              :readonly="disableFields"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 pr-4>
            <v-text-field
              v-model="loan.CurrentLoanPAndIBalance" 
              :rules="[rules.Balance]" 
              :label="`Current Loan Balance:`"
              :readonly="disableFields"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md4 pr-4>
            <date-picker
              label="Current Balance As Of"
              v-model="loan.CurrentLoanAsOfdate"
              :rules="[rules.DateRequired]"
              :readonly="disableFields"
            ></date-picker>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs1 style="display:flex; align-items:center;">
        <v-tooltip bottom>
          <template slot="activator">
            <v-btn icon color="secondary" @click="removeLender(idx)"><v-icon>clear</v-icon></v-btn>
          </template>
          <span>Remove Lender</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Rules from '../../validation/rules'
import DatePickerVue from '../DatePicker.vue';
export default {
  props: {
    loan: Object,
    idx: Number,
    disableFields: Boolean
  },
  data(){
    return {
      rules: Rules,
      menu: false
    }
  },
  created(){

  },
  methods: {
    removeLender(idx){
      this.$emit('removeLender', idx)
    }
  },
  computed: {

  },
  watch: {
    loan: {
      handler(val){
        this.$emit('input', val)
      },
      deep: true
    }
  },
  components: {
    'date-picker' : DatePickerVue
  }
}
</script>

<style>

</style>
